
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reklama",
      function () {
        return require("private-next-pages/reklama/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reklama"])
      });
    }
  